import React from "react";
import LookupBase from "./LookupBase";
import * as FS from "../styles/formStyles";

export default function LookupSong(props) {

  const endpoint = "/api/virtuous-songs";

  function queryBuilder(s) {
    const q = encodeURIComponent(s);

    return (
      `?filters[$or][0][JudulNada][$containsi]=${q}` +
      `&filters[$or][1][JudulNadaPinyin][$containsi]=${q}` +
      `&filters[$or][2][JudulLirik][$containsi]=${q}` +
      `&filters[$or][3][JudulLirikPinyin][$containsi]=${q}` +

      // optional: field select biar ringan
      `&fields[0]=JudulNada` +
      `&fields[1]=JudulNadaPinyin` +
      `&fields[2]=JudulLirik` +
      `&fields[3]=JudulLirikPinyin`
    );
  }

  function renderItem(item) {
    const hasLirik = item?.JudulLirik?.trim();

    return (
      <>
        {/* icon area (optional, biar konsisten dengan LookupUmat avatar) */}
        <div style={FS.choiceAvatar}>
          🎵
        </div>

        <div style={{ flex: 1 }}>
          {/* PRIMARY */}
          <div style={{ fontWeight: 600 }}>
            {hasLirik
              ? `${item.JudulLirik || ""} ${item.JudulLirikPinyin || ""}`
              : `${item.JudulNada || ""} ${item.JudulNadaPinyin || ""}`
            }
          </div>

          {/* SECONDARY */}
          {hasLirik && (
            <div style={{ fontSize: "0.85rem", color: "#6b7280" }}>
              {item.JudulNada} {item.JudulNadaPinyin}
            </div>
          )}
        </div>
      </>
    );
  }

  function renderChip(item, onDelete) {
    return (
      <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        <div style={{ fontWeight: 600 }}>
          {item.JudulLirik || item.JudulNada}
        </div>
        <button
          onClick={onDelete}
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
            color: "#6b7280"
          }}
        >
          ×
        </button>
      </div>
    );
  }

  return (
    <LookupBase
      endpoint={endpoint}
      queryBuilder={queryBuilder}
      renderItem={renderItem}
      renderChip={renderChip}
      placeholder="Cari lagu / 拼音 / Pinyin..."
      {...props}
    />
  );
}